__turbopack_context__.v({
  "pagination-container": "search-module-scss-module__uh5Q1W__pagination-container",
  "section": "search-module-scss-module__uh5Q1W__section",
  "section__primary-content": "search-module-scss-module__uh5Q1W__section__primary-content",
  "section__secondary-content": "search-module-scss-module__uh5Q1W__section__secondary-content",
  "section__title": "search-module-scss-module__uh5Q1W__section__title",
  "sections-container": "search-module-scss-module__uh5Q1W__sections-container",
});
